import { connect } from 'react-redux';
import CategoryListItem from './CategoryListItem.jsx';
import { toggleCategorySelect, toggleShowAll } from '../../../redux/categoryFilterReducer';

function CategoryList(props) {
	return (
		<ul id="category-list" role="menu" aria-labelledby="category-button">
			<li key="show_all" role="menuitem" >
				<CategoryListItem
					label="Zeige Alle Kategorien"
					checked={props.showAll}
					onClick={props.toggleShowAll}
					firstChild={true}
				/>
			</li>
			{
				props.categories.map((category, index) => {
					const standardPrice = category.standardPriceLevel ? category.standardPriceLevel.price.value
						: category.reducedPriceLevels[0].price.value;
					const categorySelected = props.selectedCategories.indexOf(category.categoryUUID) >= 0;
					return (
						<li key={category.categoryUUID} role="menuitem">
							<CategoryListItem
								categoryColor={category.color}
								label={category.categoryName}
								price={`${standardPrice} €`}
								checked={categorySelected}
								onClick={() => props.toggleCategory(category.categoryUUID)}
								lastChild={(index + 1) === props.categories.length}
							/>
						</li>
					);
				})
			}
		</ul>
	);
}

// ------------------------------
// Store Connection
// ------------------------------


const mapStateToProps = (state) => {
	const accessCodesEnabled = state.accessCodes.accessCodesEnabled;
	const accessCodePlUuidCodeMap = state.accessCodes.plUuidCodeMap;
	const categories = (state.event.elements[state.event.selected] || {}).categories;
	const filteredCategoriesWithFilteredPricelevels = [];

	if (accessCodesEnabled) {
		const accessCodePricelevels = Object.keys(accessCodePlUuidCodeMap);
		categories.forEach((category) => {
			if ((accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) || !category.standardPriceLevel.accessCodeNeeded ||
				(category.reducedPriceLevels.find(pl => (accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded))))) {
				const filteredStandardPl = accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) ||
				!category.standardPriceLevel.accessCodeNeeded ?
					category.standardPriceLevel : null;
				const filteredReducedPl = category.reducedPriceLevels.filter(pl =>
					(accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded));
				const categoryWithFilteredPl = Object.assign({}, category, {
					standardPriceLevel: filteredStandardPl,
					reducedPriceLevels: filteredReducedPl,
				});
				filteredCategoriesWithFilteredPricelevels.push(categoryWithFilteredPl);
			}
		});
	}

	return {
		categories: accessCodesEnabled ? filteredCategoriesWithFilteredPricelevels : categories,
		selectedCategories: state.categoryFilter.selectedCategories,
		showAll: state.categoryFilter.showAll,
	};
};

const mapDispatchToProps = (dispatch) => ({
	toggleShowAll: () => {
		dispatch(toggleShowAll());
	},
	toggleCategory: (categoryUUID) => {
		dispatch(toggleCategorySelect(categoryUUID));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps)(CategoryList);
